import React from 'react';
import { LogLevel } from '../loggerSystem';
import { useSizeWithElRef } from './useSize';
import { useRcPortalWindowContext } from './useRcPortalWindowContext';
export default function useChangedListContentsSizes(callback, itemSize, enabled, scrollContainerStateCallback, log, gap, customScrollParent) {
    var _a = useRcPortalWindowContext().externalWindow, externalWindow = _a === void 0 ? window : _a;
    var memoedCallback = React.useCallback(function (el) {
        var ranges = getChangedChildSizes(el.children, itemSize, 'offsetHeight', log);
        var scrollableElement = el.parentElement;
        while (!scrollableElement.dataset['virtuosoScroller']) {
            scrollableElement = scrollableElement.parentElement;
        }
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var windowScrolling = scrollableElement.lastElementChild.dataset['viewportType'] === 'window';
        var scrollTop = customScrollParent
            ? customScrollParent.scrollTop
            : windowScrolling
                ? externalWindow.pageYOffset || externalWindow.document.documentElement.scrollTop
                : scrollableElement.scrollTop;
        var scrollHeight = customScrollParent
            ? customScrollParent.scrollHeight
            : windowScrolling
                ? externalWindow.document.documentElement.scrollHeight
                : scrollableElement.scrollHeight;
        var viewportHeight = customScrollParent
            ? customScrollParent.offsetHeight
            : windowScrolling
                ? externalWindow.innerHeight
                : scrollableElement.offsetHeight;
        scrollContainerStateCallback({
            scrollTop: Math.max(scrollTop, 0),
            scrollHeight: scrollHeight,
            viewportHeight: viewportHeight,
        });
        gap === null || gap === void 0 ? void 0 : gap(resolveGapValue('row-gap', getComputedStyle(el).rowGap, log));
        if (ranges !== null) {
            callback(ranges);
        }
    }, [callback, itemSize, log, gap, customScrollParent, scrollContainerStateCallback, externalWindow]);
    return useSizeWithElRef(memoedCallback, enabled);
}
function getChangedChildSizes(children, itemSize, field, log) {
    var length = children.length;
    if (length === 0) {
        return null;
    }
    var results = [];
    for (var i = 0; i < length; i++) {
        var child = children.item(i);
        if (!child || child.dataset.index === undefined) {
            continue;
        }
        var index = parseInt(child.dataset.index);
        var knownSize = parseFloat(child.dataset.knownSize);
        var size = itemSize(child, field);
        if (size === 0) {
            log('Zero-sized element, this should not happen', { child: child }, LogLevel.ERROR);
        }
        if (size === knownSize) {
            continue;
        }
        var lastResult = results[results.length - 1];
        if (results.length === 0 || lastResult.size !== size || lastResult.endIndex !== index - 1) {
            results.push({ startIndex: index, endIndex: index, size: size });
        }
        else {
            results[results.length - 1].endIndex++;
        }
    }
    return results;
}
function resolveGapValue(property, value, log) {
    if (value !== 'normal' && !(value === null || value === void 0 ? void 0 : value.endsWith('px'))) {
        log(property + " was not resolved to pixel value correctly", value, LogLevel.WARN);
    }
    if (value === 'normal') {
        return 0;
    }
    return parseInt(value !== null && value !== void 0 ? value : '0', 10);
}
